export default __webpack_public_path__ + "static/media/bg.d42d1656.jpg";